module.exports = __webpack_public_path__ + "img/logo-white-text.996e32ba.svg";